module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-white-3",
    attrs: {
      "id": "ticket"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-7"
  }, [_c('h2', {
    staticClass: "font-family-alt sm-title-large title-extra-large-2 text-gray-dark-2 vw-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "bg-base-color margin-6-5 no-margin-bottom no-margin-rl separator-line-extra-thick-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial margin-6 no-margin-bottom no-margin-rl"
  }, [_c('div', {
    staticClass: "bg-white border border-gray-light border-round padding-5 width-100"
  }, [_c('p', {
    staticClass: "no-margin text-gray-dark- text-large"
  }, [_vm._t("statement")], 2)]), _vm._v(" "), (_vm.mainEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.mainEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.mainEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.mainEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.secondaryEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.secondaryEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.secondaryEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.secondaryEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.thirdEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.thirdEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.thirdEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.thirdEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.fourthEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.fourthEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.fourthEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.fourthEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.fifthEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.fifthEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.fifthEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.fifthEmployeeTitle))])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 col-md-offset-1 xs-margin-8 xs-no-margin-bottom xs-no-margin-rl"
  }, [_c('div', {
    staticClass: "pricing bg-white border border-gray-light border-round box-shadow-yes ease position-relative"
  }, [_c('div', {
    staticClass: "display-table height-100 no-padding-tb padding-13 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell no-padding-rl padding-18 text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-1 text-gray-dark-2 text-large text-uppercase"
  }, [_vm._v("PRIS FOR DELTAGELSE")]), _vm._v(" "), _c('span', {
    staticClass: "vw-bold display-block font-family-alt margin-11 no-letter-spacing no-margin-bottom no-margin-rl text-gray-dark-2 title-extra-large-4"
  }, [_vm._v("\n                                " + _vm._s(_vm.price) + "\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "bg-gray-light-2 margin-10-5 no-margin-bottom no-margin-rl separator-line-full"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled margin-11 no-margin-bottom no-margin-rl text-gray-dark2 text-large text-left"
  }, [_vm._t("benefits")], 2), _vm._v(" "), _c('p', {
    staticClass: "margin-11 no-margin-bottom no-margin-rl text-gray-dark-2 text-medium"
  }, [_vm._v("Tilmelding skal ske senest 10 dage før arrangementets start, da mad & drikke bestilles forinden.")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc98933"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/statement-and-price.vue
// module id = 244
// module chunks = 1